var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframeUrl)?_c('div',{staticClass:"HtmlPanel"},[_c('iframe',{ref:"iframe",class:_vm.iframeId,style:({height:_vm.iframeHeight+'px',width:'100%'}),attrs:{"id":_vm.iframeId,"scrolling":"no","border":"0","frameborder":"no"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2728709f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HtmlPanel.vue
// module id = null
// module chunks = 